import type { ProductCardDataType } from "@shared/ui.components";
import { useCallback } from "react";
import { useSegment } from "tracking";
import type { ResultType } from "@shared/graphql.types";
import { useCurrencyCode } from "hooks/useCurrencyCode";
import type { SegmentTrackProductClickedEvent } from "@beautypie/segment/Track/ProductClicked";
import type { TrackingContext } from "../types";

export const useProductCardTracking = (
  product: ProductCardDataType,
  context: TrackingContext
) => {
  const currency = useCurrencyCode();

  const { track } = useSegment();

  const resultTypes: ResultType[] = [
    "browse",
    "recommendation",
    "search",
    "suggestions"
  ];
  const isResultTypeValid =
    context.resultType && resultTypes.includes(context?.resultType);

  const trackProductClick = useCallback(() => {
    const productClickedEvent: SegmentTrackProductClickedEvent = {
      event: "Product Clicked",
      properties: {
        sku: product.sku,
        name: product.productName,
        brand: product.brandName,
        variant: product.variationName,
        members_price: product.primaryPriceRaw,
        typical_price: product.secondaryPriceRaw,
        url: product.href,
        currency,
        ...(context.resultId && { result_id: context.resultId }), //empty for current plp, add result id for constructor browse
        ...(context.position && { position: context.position }),
        ...(context.numResultsPerPage && {
          resultCount: context.numResultsPerPage
        }),
        ...(isResultTypeValid && { result_type: context.resultType })
      }
    };

    track(productClickedEvent, context.contextOverride ?? {});
  }, [product, context, currency, isResultTypeValid, track]);

  return { trackProductClick };
};
